const messages = {
    en: {
        translations: {
            code: "Code",
            description: "Description",
            search: "Search",
            active: "Active",
            created_at: "Created at",
            modified_at: "Updated at",
            actions: "Actions",
            cancel: "Cancel",
            save: "Save",
            sector: "Sector",
            production_line: "Production Line",
            automatic_phase: "Automatic Phase",
            phase: "Phase",
            machine: "Machine",
            process: "Process",
            new: "New",
            cost_center: "Cost center",
            tag_code: "Tag code",
            criticality: "Criticality",
            efficiency: "efficiency",
            last_maintenance_date: "Last maintenance date",
            frequency: "Frequency",
            utilization_index: "Utilization index",
            used_calendar: "Used calendar",
            conference_property: "Conference property",
            security_interval: "Security interval",
            unlimited_resource: "Unlimited resource",
            area: "Area",
            sequence: "Sequence",
            centesimal_working_hours: "Centesimal working hours",
            saturday_working_hours: "Saturday working hours",
            sunday_working_hours: "Sunday working hours",
            period_working_hours: "Period working hours",
            period_used_hours: "Period used hours",
            yield_percentage: "Yield percentage",
            warehouse_consumption: "Warehouse consumption",
            warehouse_description: "Warehouse description",
            shift: "Shift",
            initial: "Initial time",
            final: "Final time",
            start: "Start",
            product: "Product",
            unit_measurement: "Unit measurement",
            abbreviation: "Abbreviation",
            rows_per_page: "Rows per page",
            product_details: "Product details",
            item_code: "Item code",
            alternative_code: "Alternative code",
            specific_description: "Specific description",
            portuguese_description: "Portuguese description",
            english_description: "English_description",
            nickname: "Nickname",
            username: "Username",
            password: "Password",
            recoverPassword: "Recover password",
            confirmPassword: "Confirm password",
            email: "Email",
            superuser: "Super User",
            product_type: "Product type",
            raw_material: "Raw material",
            finished_product: "Finished product",
            intermediate_product: "Intermediate product",
            model: "Model",
            part_number: "Part number",
            part_number_client: "Part number client",
            manufacturer: "Manufacturer",
            expiration_date: "Expiration date",
            gross_weight: "Gross weight",
            revision: "Revision",
            last_revision: "Last revision",
            minimum_grade: "Minimum grade",
            division: "Division",
            inventory_frequency: "Inventory frequency",
            base_quantity_structure: "Base quantity structure",
            decimal_places_production_order: "Decimal places production order",
            normal_treatment_without_decimals: "Normal treatment without decimals",
            round: "Round",
            increments: "Incrementa",
            truncate_decimal_places: "Truncate decimal places",
            model_car: "Model car",
            direct_or_indirect_appropriation: "Direct or indirect appropriation",
            direct: "Direct",
            indirect: "Indirect",
            optional_default_group: "Optional default group",
            truncate_or_round: "Truncate or round",
            truncate: "Truncate",
            block: "Block",
            enter_mrp: "Enter MRP?",
            attend_need: "Attend need",
            notes: "Notes",
            unit_of_measurement: "Unit of measurement",
            unit_measurement_internal: "Unit measurement internal",
            unit_measurement_entry: "Unit measurement entry",
            second_unit_measurement: "Second unit measurement",
            conversion_factor: "Conversion factor",
            conversion_type: "Conversion type",
            multiplies: "Multiplies",
            divide: "Divide",
            cost_purchase: "Cost/Purchase",
            default_supplier: "Default supplier",
            store_default_supplier: "Store default supplier",
            minimum_quantity_order: "Minimum quantity oorder",
            reference_value_uss: "Reference value US$",
            sale_price: "Sale price",
            last_purchase_currency: "Last purchase currency",
            last_purchase_value: "Last purchase value",
            last_purchase: "Last purchase",
            default_cost_currency: "Default cost currency",
            default_cost: "Default cost",
            last_calculation_default_cost: "Last calculation default cost",
            fob_cost_currency: "Fob cost currency",
            fob_cost: "Fob cost",
            last_calculation_fob_cost: "Last calculation fob cost",
            delivery_time: "Delivery time",
            delivery_time_type: "Delivery time type",
            hours: "Hours",
            days: "Days",
            months: "Months",
            years: "Years",
            calculation_delivery_time_formula: "Calculation delivery time formula",
            tolerance: "Tolerance",
            stock: "Stock",
            stock_group: "Stock group",
            maximum_stock: "Maximum stock",
            security_stock: "Security stock",
            economic_lot: "Economic lot",
            minimum_lot: "Minimum lot",
            packing_quantity: "Packing quantity",
            security_stock_formula: "Security stock formula",
            default_warehouse: "Default warehouse",
            traceability: "Traceability",
            product_origin: "Product origin",
            national: "Product origin",
            foreign_direct_import: "Product origin",
            foreign_adq_domestic_market: "Product origin",
            foreign: "Product origin",
            product_traceability: "Product traceability",
            subbatch_traceability: "Subbatch traceability",
            does_not_use_traceability: "Does not use traceability",
            batch_traceability: "Batch traceability",
            default_production_map_operation: "Default production map operation",
            copy_quantity_bar_code: "Copy quantity bar code",
            bar_code: "Bar code",
            imported_product: "Imported product",
            purchased_out_state: "Purchased out state",
            family: "Family",
            ghost: "Ghost",
            controls_addressing: "Controls addressing",
            own_third_or_party: "Own third or party",
            own: "Own",
            third: "Third",
            product_base: "Product base",
            product_component: "Product component",
            loss_index: "Loss index",
            initial_validity: "Initial validity",
            final_validity: "Final validity",
            process_time: "Process time",
            quantity_type: "Quantity type",
            optional_group: "Optional group",
            item_optional_group: "Item optional group",
            initial_revision: "Initial revision",
            final_revision: "Final revision",
            product_level: "Product level",
            reverse_product_level: "Reverse product level",
            lot_potency: "Lot potency",
            warehouse: "Warehouse",
            quantity: "Quantity",
            alternative_use: "Alternative use",
            file_imported: "File imported",
            import_file: "Import file",
            import: "Import",
            user: "User",
            name: "Name",
            legacy_code: "Legacy code",
            group: "Group",
            menu: "Menu",
            visible: "Visible",
            permission: "Permission",
            successfully_updated: "Successfully updated",
            successfully_registered: "Successfully registered",
            successfully_deleted: "Successfully deleted",
            successfully_uploaded: "Successfully uploaded",
            required_field: "The field is required",
            exceeds_character_limit: "Exceeded character limit.",
            must_be_a_integer_number: "must be a integer number",
            must_be_a_number: "must be a number",
            unique_validation_failure: "unique validation failure",
            must_be_a_positive_number: "must be a positive number",
            cannot_insert_update_duplicate_key: "Cannot insert or update duplicate key",
            fixed: "Fixed",
            variable: "Variable",
            invalid_time_format: "Invalid time format",
            invalid_date_format: "Invalid date format",
            invalid_number_format: "Invalid number format",
            default_moment_locale: "en-in",
            token_error_redirecting: "Token error. Redirecting...",
            of: "of",
            basic_inputs: "Basic inputs",
            product_process: " Product - Process",
            invalid_file: "Invalid file",
            enter: "Enter",
            welcome_home: "Welcome to",
            invalid_credentials: "Unable to log in with the provided credentials.",
            logout: "Logout",
            profile: "Profile",
            session_expired: "Your session has expired.",
            session_information: "Log in to stay connected.",
            login_failed: "Unable to login, please check your connection.",
            confirm: "Confirm",
            edit: "Edit",
            delete: "Delete",
            save_form: "Save",
            superUser: "Administrator",
            confirm_delete: "Are you sure you want to delete this item?",
            password_not_match: "The passwords do not match.",
            product_line: "Product line",
            planning: "Planning",
            simulation: "Simulation",
            is_active: "Active",
            is_superuser: "Superuser",
            module: "Module",
            modules: "Modules",
            root_description: "Module",
            empty_listing: "No records found.",
            no_shift: "No shifts found.",
            new_password: "New password",
            confirm_new_password: "Confirm new password",
            undefined: "Undefined",
            security: "Security",
            status: "Status",
            inactive: "Inactive",
            codename: "Code",
            redefine_password: "Redefine password",
            grant_permission: "Grant all permissions.",
            deny_permission: "Deny all permissions.",
            codename_or_name: "Name / Code",
            error_user_selected: "Select a user to add the permission.",
            history: "History",
            history_update: "Updated",
            history_create: "Created",
            history_delete: "Deleted",
            is_staff: "Is staff",
            is_default: "Is default",
            true: "Yes",
            false: "No",
            modified_to: "modified to",
            general: "General",
            type_process: "Type process",
            hybrid: "Hybrid",
            available_production_line: "Available for production line:",
            used_production_line: "Used on the production line:",
            info_ordination: "Drag items to sort them.",
            segment: "Product Segment",
            station: "Station",
            programmed: "Programmed Shutdown",
            unscheduled_stop: "Unscheduled stop",
            confirm_type_process: "Confirm change.",
            confirm_type_process_text: "This production line has an associated station, do you really want to change the type of process? Associations will be lost.",
            programmed_shutdown: "Programmed Shutdown",
            duration: "Duration",
            type: "Type",
            commercial: "Part Number Commercial",
            name_or_commercial: "Commercial Part Number or Product",
            start_validity: "Validity start",
            end_validity: "Validity end",
            search_name: "Search name",
            search_programmed: "Search programmed",
            validity_start_date: "Validity start date",
            validity_end_date: "Validity end date",
            start_time: "Start time",
            end_time: "End time",
            error_required_field: "Make sure all required fields are filled in.",
            invalid_group: "A group with this name already exists.",
            the_record_already_exists: "The record already exists",
            replanning_reason: "Replanning Reason",
            reason: "Reason",
            cause: "Default Cause",
            yes: "Yes",
            no: "No",
            loading: "Loading",
            invalid_format: "Invalid format",
            order: "Order",
            search_shift: "Search shift",
            workday: "Workday",
            length: "Duration",
            error_programmed_selected: "Select a programmed shutdown to associate with the shift.",
            module_options: "What do you want to do?",
            production_capacity: "Production capacity",
            basic: "Basic",
            reports: "Reports",
            settings: "Settings",
            access_control: "Access control",
            invalid_email: "You must enter a valid email.",
            registrations: "Registrations",
            demand: "Demand",
            production_planning: "Production Planning",
            replanning_history: "Replanning history",
            smt_default_time: "Default SMT time",
            manual_default_time: "Manual default time",
            scheduled_stop: "Scheduled stops",
            reason_replanning: "Replanning reason",
            production_ramp: "Production ramp",
            calendar_event_type: "Calendar event type",
            calendar: "Calendar",
            marker: "Bookmark",
            reason_replanning_report: "Replanning reasons",
            production_line_usage: "Usage of production lines",
            realized_vs_planned: "Realized vs planned",
            preferences: "Preferences",
            expression_builder: "Expression Builder",
            headcount: "Number of people",
            stops: "Stops",
            line_configuration: "Line configuration",
            default: "Default",
            color: "Color",
            search_description: "Search description",
            useful_day: "Useful day",
            day_off: "Day off",
            pn_commercial: "PN Comercial",
            is_top_bottom: "Top-Bottom",
            component: "Component",
            sides: "Sides",
            add: "To add",
            production_ramp_settings: "Production ramp settings",
            npi: "NPI",
            module_under_construction: "Module under construction",
            module_under_construction_description: "This area doesn't have any features available yet. New updates coming soon.",
            no_modules_available: "No modules available for your profile. Request access from an administrator if needed.",
            back_to_home: "Back to homepage",
            side: "Side",
            version: "Version",
            production_order: "Production order",
            reference_date: "Reference date",
            font_color: "Font color",
            production_order_peripheral: "Production order peripherals",
            lines: "Lines",
            production_ramp_day: "Day ",
            validate_production_lines: "Production lines must contain the same settings",
            duplicate: "Duplicate",
            default_time_seconds: "Standard time",
            people_quantity: "People quantity",
            capacity: "Capacity",
            default_expression: "Default expression:",
            expression: "Expression",
            initial_date: "Initial date",
            final_date: "Final date",
            available: "Available",
            planned: "Planned",
            in_production: "In production",
            finished: "Finished",
            january: "January",
            february: "February",
            march: "March",
            april: "April",
            may: "May",
            june: "June",
            july: "July",
            august: "August",
            september: "September",
            october: "October",
            november: "November",
            december: "December",
            message_home: "NRE Control is a production planning system.",
            save_plus: "Save +",
            close: "Close",
            clear: "Clear",
            open: "Open",
            month: "Month",
            year: "Year",
            event: "Event",
            start_date: "Start date",
            end_date: "End date",
            validate_end_time: "This time must be longer",
            validate_event_create: "It is only allowed to create an event after the current date",
            available_time: "Available time",
            return_value: "Return value",
            default_time: "Default time",
            assemble_expression: "Assemble the expression",
            set_default_expression: "Set as default expression",
            AVAILABLE_TIME: "AVAILABLE TIME",
            DEFAULT_TIME: "DEFAULT TIME",
            PEOPLE_QUANTITY: "PEOPLE QUANTITY",
            CAPACITY: "VOLUME",
            volume: "Volume",
            day: "Day",
            line: "Line",
            duplicate_version: "Duplicate version",
            delete_version: "Delete version",
            change_final_version: "Change to final version",
            duplicate_version_successfully: "Duplicate version successfully",
            confirm_make_version_final: "Do you really want to make version ($description) final?",
            to_plan: "To plan",
            sunday: "Sunday",
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            new_marker: "New marker",
            peripheral: "Peripheral",
            interrupt_demand: "Interrupt demand",
            markers: "Markers",
            remove_planning_message: "Want to remove the planning?",
            can_not_edit_planning_with_final_version: "You cannot make a change to a production version. Change a duplicate version and then publish",
            production_line_top: "Production line TOP",
            production_line_bot: "Production line BOTTON",
            demand_total: "Demand total",
            shift_to_start: "Shift to start",
            line_setup_stop: "Line setup stop",
            different_line: "Phases A and B in different lines",
            shifts: "Shifts",
            production_line_backend: "Backend production line",
            associate_shift: "Associate shift",
            no_associated_shift: "No associated shift",
            value_day_one: "Value day 1",
            value_day_two: "Value day 2",
            value_day_three: "Value day 3",
            value_day_four: "Value day 4",
            value_day_five: "Value day 5",
            value_day_six: "Value day 6",
            value_day_seven: "Value day 7",
            production_line_required: "Select at least one production line",
            info_demand: "Demand information",
            edit_demand: "Demand edit",
            history_month: "Monthly history",
            balance: "Balance",
            planned_quantity: "Planned",
            move_balance: "Move balance",
            bone_pile: "Defect",
            scrap: "Waste",
            realized: "Realized",
            finalize_demand: "Finalize demand",
            info_finalize_demand: "Do you want to finalize the demand?",
            finalize: "Finalize",
            smt_configuration: "No SMT time setting",
            manual_configuration: "No Manual time setting",
            unknown_error: "Oops... there was an unexpected thing!",
            service_unavailable: "The system is temporarily unavailable due to an update or maintenance. Please try again in a few minutes.",
            new_simulation: "New optimization",
            new_version: "New version",
            all_rights_reserved: "All rights reserved",
            developed_by: "Developed by",
            edit_planning: "Edit planning",
            smt_warnning: "SMT time",
            manual_warnning: "Manual time",
            valid_quantity: "Quantity cannot exceed the demand value",
            anticipate_planning: "Anticipate upcoming plans",
            replanning_amount: "Replanning amount",
            date: "Date",
            must_be_bigger_equal_than_start_date: "Must be bigger or equal than start date",
            must_be_less_equal_than_final_date: "Must be less or equal than final date",
            must_be_bigger_than_start_date: "Must be bigger than start date",
            must_be_less_than_final_date: "Must be less than final date",
            must_be_bigger_than_start_time: "Must be bigger than start time",
            must_be_less_than_final_time: "Must be less than final time",
            line_setup: "Line setup",
            no_records_found: "No records found",
            demand_used_hours: "Demand used hours",
            group_by: "Group by",
            consolidated: "Consolidated",
            detailed: "Detailed",
            import_material_transit: "Import material in transit",
            product_description: "Product description",
            delivery_date: "Delivery date",
            result: "Result",
            side_a: "Side A",
            side_b: "Side B",
            max_qtd: "Max quantity ",
            product_model: "Product model",
            title_event: "event",
            attention: "Attention",
            exists_planning: "There is already planning for this period, do you want to continue and replan?",
            add_delay: "Fill in to delay the start of the back-end production line.",
            delivery: "Delivery",
            planning_by_delivery: "Planning by delivery",
            no_planned: "No planned",
            input: "Input",
            create_demand: "Create demand",
            simulation_options: "Simulation options",
            max_value: "The field can't be greater than ",
            min_value: "The field can't be lesser than ",
            invalid_quantity: "Insufficient quantity to create demand",
            value: "Value",
            MAIL_HOST: "Mail host",
            MAIL_PORT: "Mail port",
            MAIL_SENDER: "Mail sender",
            MAIL_PASSWORD: "Mail password",
            MAIL_USE_TLS: "Mail use TLS",
            MAIL_USE_SSL: "Mail use SSL",
            DEMAND_DAYS_BEFORE_VALIDATE: "Days before validate demands",
            EMAILS_TO_ALERT: "E-mails to alert",
            PRODUCTION_PLAN_XLS_PATH: "Path to generate planning xls",
            notifications: "Notifications",
            verify_demand: "Verify demand",
            production_line_manual: "Linha de produção manual",
            production_line_smt: "Linha de produção SMT",
            next: "Next",
            previous: "Previous",
            select_demand: "Selecionar demanda",
            adjust_variables: "Adjust variables",
            define_period_and_shifts: "Set shifts and period",
            top_bottom_different_line: "Top / Bottom in different production line",
            planned_qty: "Qty. planned",
            head_count: "Head count",
            production_time: "Production time",
            ramp: "Ramp",
            input_a_value: "Input a value",
            greater_than_equal_0: "The field must be greater than or equal to 0",
            greater_than_equal_1: "The field must be greater than or equal to 1",
            less_than_equal_1000: "The field must be less than 1000",
            generate_demand: "Generate demands",
            line_setting: "Line setting",
            smt: "SMT",
            manual: "Manual",
            aligned: "Aligned",
            create: "Create",
            delete_simulation: "Clear future plannings",
            simulation_result: "Simulation result",
            sync: "Sync",
            delayed: "Delayed",
            total_simulations: "Total simulations",
            plannings_removed: "Plannings removed",
            optimization_progress: "Optimization progress",
            optimization_started: "Optimization started",
            optimization_finalized: "Optimization finalized",
            downtime_reason: "Downtime reason",
            downtime: "Downtime",
            scheduled: "Scheduled",
            unscheduled: "Unscheduled",
            downtime_ranking: "Stops ranking",
            reason_qty: "Reason quantity",
            downtime_summary_by_quantity_report: "Downtimes by time and quantity",
            downtime_summary_by_available_time_report: "Downtimes by available time",
            downtime_by_year: "Downtime by year",
            downtime_by_month: "Downtime by month",
            downtime_by_week: "Downtime by week",
            downtime_by_day: "Downtime by day",
            report_by_available_time: "Report by available time",
            time: "Time",
            report_type: "Report type",
            planned_quantity_required: "Planned quantity is required",
            capacity_required: "Capacity is required",
            import_production: "Import production",
            verify_planning: "Verify planning",
            produced_quantity: "Produced quantity",
            week: "Week",
            qty: "Quantity",
            product_name: "Product",
            segment_name: "Segment",
            realized_and_planned_by_year: "Realized vs planned by year",
            realized_and_planned_by_month: "Realized and planned bymonth",
            realized_and_planned_by_week: "Realized and planned by week",
            realized_and_planned_by_day: "Realized and planned by day",
            production_import_successful: "Production imported successfully",
            nothing_to_import: "Nothing to import",
            start_week: "Start week",
            end_week: "End week",
            must_be_bigger_equal_than_start_week: "Must be bigger equal than start week",
            select_by: "Select by",
            oee_month_goal: "OEE month goal",
            oee_year_goal: "OEE year goal",
            goal: "Goal",
            oee: "OEE",
            monthly: "Monthly",
            weekly: "Weekly",
            oee_one: "O.E.E.1",
            monthly_oee: "Monthly OEE1",
            year_oee: "Year OEE1",
            month_target: "Year target",
            year_target: "Month target",
            dashboard: "Dashboard",
            dashboard_oee: "Dashboard OEE",
            period: "Period",
            achieved: "Achieved",
            percentage: "Percentage",
            backlog: "Backlog",
            current_year_realized: "Current year realized",
            current_year_backlog: "Current year backlog",
            current_month_realized: "Current month realized",
            current_week_realized: "Current week realized",
            ft_test_buffer: "FTTest Buffer",
            wip_volume: "Wip Volume",
            import_line_schedule: "Import line schedule",
            serial_number: "Serial number",
            rev: "REV",
            bios_rev: "BIOS REV",
            model_name: "Model name",
            group_name: "Group name",
            next_station: "Next station",
            last_log: "Last log",
            working_time: "Working time",
            emp_no: "EMP NO",
            rota: "ROTA",
            total: "Total",
            line_schedule: "Line schedule",
            hour: "Hour",
            today: "Today",
            production_order_demand: "Demand's production orders",
            buffer_chart: "Buffer Chart",
            delivery_file: "Delivery file",
            columns: "Columns",
            released_forecast: "Released forecast",
            total_backlog: "Total Backlog",
            slc_on_hand: "SLC On-Hand (LT=0)",
            factory_on_hand: "Factory On-Hand",
            projected_inventory: "Projected Inventory",
            projected_dsi: "Projected DSI",
            local_balance: "Local Inventory",
            update_with_planned: "Update with planned",
            active_line_count: "Active lines",
            active_line_shift: "Active lines by shift",
            safety_stock_ok: "Safety stock ok",
            excess_stock: "Excess stock",
            stock_on_alert: "Stock on alert",
            critical_stock: "Critical stock",
            active_people_count: "Active people",
            active_people_line: "Active people per line",
            upph: "UPPH",
            uph: "UPH",
            upph_production_line: "UPPH production line",
            send_final_version_planning: "Send final version",
            successfully_send_planning: "Planning sent successfully",
            final_version_planning: "Final version planning",
            select_an_item_below: "Select an item below",
            more_options: "More options",
            invalid_emails: "Enter valid emails separated by semicolons.",
            last_updated: "Last updated",
            next_updated: "Next updated",
            automatic: "Automatic",
            manual_or_smt: "Manual or SMT",
            urgent_planning: "Urgent planning",
            initial_quantity: "Initial quantity",
            yearly_chart: "Yearly chart",
            monthly_chart: "Monthly chart",
            weekly_chart: "Weekly chart",
            daily_chart: "Daily chart",
            info_search_reports: "The values displayed correspond to the selected period",
            category: "Category",
            categories: "Categories",
            category_name: "Category name",
            new_category: "New category",
            projects: "Projects",
            project_name: "Project name",
            new_project: "New project",
            client: "Client",
            part_numbers_register: "Part Numbers Register",
            search_po_monitoring: "Search by PO number, PR number, category or project",
            completed: "Completed",
            pending: "Pending",
            canceled: "Canceled",
            po_number: "PO number",
            origin: "Origin",
            po_monitoring: "PO Monitoring",
            purchase_date: "Purchase date",
            all: "All",
            search_project: "Search project by name",
            edit_project: "Edit project",
            select_client: "Select client",
            add_project: "Add project",
            selected_projects: "Selected projects",
            no_projects_selected: "No projects selected",
            po_details: "PO details",
            pr_number: "PR number",
            project: "Project",
            po_total: "PO Total",
            add_category: "Add category",
            select_category_po: "Select a category for the PO:",
            select_category: "Select a category",
            classify: "Classify",
            po_added: "PO added",
            po_delivered: "PO delivered",
            po_in_partial_delivery: "PO in partial delivery",
            added: "Added",
            detail: "Detail",
            purchase_orders: "Purchase orders",
            import_date: "Import date",
            import_status: "Import status",
            processing: "Processing",
            amortization: "Amortization",
            latest_importation: "Latest importation",
            import_nre_costs: "Import NRE costs",
            download: "Download",
            amortizations: "Amortizations",
            asset_control: "Asset control",
            commodatum_agreements: "Commodatum agreements",
            export: "Export",
            see_nfs: "See NFs",
            invoices: "Invoices",
            import_related_costs: "Import of Related Costs",
            import_related_costs_btn: "Import Related Costs",
            related_costs: "Related Costs",
            select_lob: "Select LOB",
		  	    successfully_import: "File added successfully.",
            add_invoice_btn: "Add Invoice",
            add_invoice: "Add Invoice",
            select_project: "Select project",
            invoice_code: "Invoice code",
            partnumber_desc: "PartNumber/Description",
            partnumber_desc_info: "Inform partnumber and description of invoice",
            invoice_value: "Invoice value",
            imports: "Imports",
            projects_for_amortization: "Projects for Amortization",
            equal_value_for_all_projects: "Equal value for all projects",
            amortization_value: "Amortization value",
            nre_cost_exists: "Already exists a invoice number for this project and category.",
            sum_of_values_greater_than_invoice_value: "Sum of values can't be greater than invoice value.",
            project_exists: "Already exists a project with this name.",
            search_category: "Search by name or description",
            cost_allocation_by_project_category: "Cost allocation by project and category",
            nu_po: "Nº PO",
            created_date: "Created date",
            total_po: "Total PO",
            value_by_project: "Value by project",
            search_po_by_code: "Search PO by code",
            list_material_po: "List of materials by PO",
            plan: "Plan",
            search_material: "Search material",
            stock_and_materia_output: "Stock and Material Output",
            report_stock_and_materia_output: "Report of Stock and Material Output",
            who_removed: "Who removed",
            remove_date: "Remove date",
            qty_avaible: "Qty available",
            last_update: "Last update",
            year_month: "Year/Month",
            report_ftb_general: "FTB General Report",
            ftb_general: "FTB General",
            search_material_by_code_partnumber_description: "Search by material code of part number, description or Alt Grp Grl",
            total_produced: "Total produced",
            quantity_of_jiga: "Quantity of Jiga",
            add_partnumber: "Add PartNumber",
            registered_partnumbers: "Registered PartNumbers",
            no_registered_partnumber: "No registered PartNumber",
            ft_bom_groups: "Material Groups",
            new_ft_bom_group: "New Group",
            edit_ft_bom_group: "Edit Group",
            search_ft_bom_group: "Search group by code or description, and materials",
            description_en: "Description EN",
            description_pt: "Description PT",
            associate_materials: "Associate Materials",
            associate_btn: "Associate",
            search_ft_bom: "Search material by code part number or description",
            group_exists: "Already exists a group with this code.",
            total_nre: "NRE Total",
            total_amortized: "Amortized Total",
            open_nre: "Open NRE",
            qty_po_partial: "PO in partial delivery",
            qty_po_added: "PO in pending of classification",
            mount_jiga_rma: "Mount JIGA/RMA",
            quantity_of_rma: "Quantity of RMA",
            category_cost_by_year: "Category Cost by Year",
            po_uncategorized_filter: "Pending Classification",
            reuse_ftb_material: "Reuse FTB Material",
            reuse: "Reuse",
            pending_groups: "Pending Groups",
            reused_ftb_material: "Reused FTB Material",
            edit_reused_ftb_material: "Edit Reused FTB Material",
            replenishment: "Replenishment",
            last_replenishment: "Last replenishment",
            clients: "Clients",
            sapCode: "SAP Code",
            new_client: "New client",
            search_client: "Search by name or SAP code",
            edit_client: "Edit client",
            client_association_with_po: "Cannot delete client with associated POs.",
            client_association_with_project: "Cannot delete client with associated project.",
            client_association_with_ftbom: "Cannot delete client with associated FTBOM.",
            add_client: "Add client",
            select_client_po: "Select the client of PO:",
            select_client_ftb: "Select the client of FTB:",
            users: "Users",
            new_user: "New user",
            user_type: "User type",
            complete_name: "Complete name",
            no_replenishment_info: "No upcoming replenishment",
            pending_nre_invoices: "Pending NRE invoices",
            integration_routines: "Integration routines (RFC - SAP)",
            confirmation_monitoring_po: "Confirmation of POs for NRE Monitoring",
            confirm_sending_po: "Confirm the sending of POs",
            confirm_sending: "Confirm sending",
            report: "Report",
            send_po: "Send PO",
            permission_denied_title: "Access not allowed",
            permission_denied_message: "Your profile does not have permission to access this area. Request access from an administrator if needed.",
            configuration: "Configuration",
            template: "Template",
            new_npi: "New NPI",
            export_label: "Export",
            export_image_png: "Image (PNG)",
            export_image_error: "Could not generate the dashboard image.",
            generated_at: "Generated at",
            planning_template: "Planning Templates",
            board: "Board",
            monitor: "Monitor",
            activity: "Activity",
            resource: "Resource",
            baseline_start: "Baseline start",
            baseline_end: "Baseline end",
            exec_start: "Exec start",
            exec_end: "Exec end",
            atrasado_ha: "Delayed for",
            dias: "days",
            nao_iniciada_label: "Not started",
            concluido_label: "Completed",
            em_andamento_label: "In progress",
            atrasado_label: "Delayed",
            id: "ID",
            project_planning: "Project planning",
            npi_project: "NPI Project",
            progress: "Progress",
            total_projects: "Total projects",
            completed_steps: "Completed steps",
            in_progress_summary: "Activities in progress",
            pending_not_started: "Pending activities (not started)",
            search_step_or_project: "Search project, phase or step...",
            npi_dashboard_empty_title: "No projects to display",
            npi_dashboard_empty_description: "There are no NPI projects for the selected filters. Adjust the client, year or project type.",
            npi_dashboard_no_results_title: "No results found",
            npi_dashboard_no_results_description: "No project, phase or step matches \"{{term}}\".",
            delayed_for_3_days: "Delayed for 3 days",
            dashboard_step: "Step",
            status_delayed_legend: "Delayed",
            status_running_legend: "Running",
            activities: "Activities",
            frc: "FRC",
            execution_start: "Execution Start",
            execution_end: "Execution End",
            status_completed: "Completed",
            status_completed_late: "Completed late",
            status_in_progress: "In progress",
            status_delayed: "Delayed",
            status_not_started: "Not started",
            status_not_executed: "Will not be executed",
            complete_activity: "Complete activity",
            duration_change_warning: "Changing the duration will impact the rest of the schedule.",
            duration_must_be_positive: "Duration must be greater than zero.",
            mark_not_executed: "Mark as will not be executed",
            undo_not_executed: "Undo will not be executed",
            delayed_days_ago_one: "Delayed by {{count}} day",
            delayed_days_ago_other: "Delayed by {{count}} days",
            completed_late_days_one: "Completed {{count}} day late",
            completed_late_days_other: "Completed {{count}} days late",
            new_activity: "New Activity",
            new_template: "New Template",
            edit_template: "Edit Template",
            search_template: "Search by template name",
            template_name: "Template name",
            project_type: "Project type",
            new_project_type: "New project type",
            edit_project_type: "Edit project type",
            create_new: "Create new",
            project_type_in_use: "This project type is in use and cannot be deleted",
            copy_template: "Copy template",
            none: "None",
            back: "Back",
            select: "Select",
            copy: "Copy",
            new_group: "New group",
            total_deadline: "Total deadline",
            phases: "Phases",
            task_name: "Task name",
            task_status: "Status",
            task_acronym: "Task (acronym)",
            deadline: "Deadline",
            predecessor: "Predecessor",
            no_predecessor: "No predecessor",
            search_task: "Search task...",
            template_detail: "Template Detail",
            no_groups: "No groups added to template",
            name_of_group: "Group name",
            new_subgroup: "New subgroup",
            save_to_set_predecessor: "Save the task to set a predecessor",
            group_already_added: "A group with this name already exists.",
            task_acronym_already_added: "An activity with this acronym already exists.",
            confirm_delete_group: "Are you sure you want to delete this group?",
            confirm_delete_activity: "Are you sure you want to delete this activity?",
            template_already_added: "A NPI template with this name already exists.",
            project_type_already_added: "A project type with this name already exists.",
            calendars: "Calendars",
            select_calendar: "Select calendar",
            side_by_side: "Side by side",
            view_mode: "View mode",
            legend: "Legend",
            national_holiday: "National Holiday",
            manaus_holiday: "Manaus Holiday",
            sao_paulo_holiday: "São Paulo Holiday",
            holiday: "Holiday",
            tiaoxiu_legend: "Tiaoxiu (Sat/Sun working in CHINA)",
            weekend: "Weekend",
            normal_business_day: "Normal Business Day",
            annual_calendar: "Annual Calendar",
            add_holiday: "Add holiday",
            brasil: "Brasil",
            china: "CHINA",
            holidays_and_events_of_month: "Holidays & Events of the Month",
            no_holidays_this_month: "No holidays this month",
            confirm_delete_holiday: "Are you sure you want to delete this holiday?",
            holidays_and_events_of_year: "Holidays & Events of the Year",
            expand_group: "Expand group",
            collapse_group: "Collapse group",
            template_linked_to_npi: "It is not allowed to delete a template linked to an NPI.",
            feriado: "Holiday",
            tiaoxiu: "Tiaoxiu",
            confirm_status_change: "Are you sure you want to complete this activity?",
            confirm_mark_not_executed: "Are you sure you want to mark this activity as will <bold>not be executed</bold>?",
            confirm_undo_not_executed: "Are you sure you want to undo the will <bold>not be executed</bold> status for this activity?",
            confirm_delete_npi: "Are you sure you want to delete this NPI template?",
            confirm_delete_header: "Delete NPI Item",
            npi_checklist: "NPI Checklist",
            npi_product_checklist: "NPI Product Checklist",
            new_npi_checklist: "New Product Checklist (NPI)",
            product_project_name: "Model Name / Project Name",
            insert_part_number: "Insert the part number",
            part_number_read_only: "To change it, remove the part number using the trash icon and add it again",
            part_number_already_added: "This part number has already been added.",
            checklist_template: "Checklist Template",
            click_to_add_file: "Click here to add the file.",
            excel_max_size: "XLS or XLSX (max. 5MB)",
            remove_file: "Remove file",
            file_exceeds_max_size: "The file must be at most 5MB.",
            checklist_schedule: "Schedule",
            checklist_filters: "Filters",
            checklist_all_status: "All Status",
            checklist_responsible: "Responsible",
            checklist_responsibles: "Responsibles",
            checklist_clear_filters: "Clear filters",
            checklist_send_report: "Send report",
            checklist_item: "Item",
            checklist_requirement_description: "Requirement description",
            checklist_final_deadline: "Final deadline",
            checklist_completion_date: "Completion date",
            checklist_no_items_found: "No items found for the selected filters.",
            checklist_validate: "Validate",
            checklist_comment: "Comment",
            npi_transfer_phases: "NPI phases schedule (transfer phases)",
            npi_transfer_progress: "NPI Transfer Progress",
            checklist_completed_label: "Complete",
            phase_completed: "Completed",
            phase_in_progress: "In Progress",
            phase_pending: "Pending",
            checklist_status_overview: "Checklist & NPI demands overall status",
            mapped_requirements: "mapped requirements",
            checklist_complete: "Complete",
            checklist_on_going: "On going",
            checklist_at_risk: "At risk / Pending",
            checklist_not_applicable: "N/A",
            checklist_legend_green: "Green",
            checklist_legend_yellow: "Yellow",
            checklist_legend_red: "Red",
            oem_client: "OEM / Client",
            odm_manufacturer: "ODM / Manufacturer",
            part_numbers: "Part numbers",
            pcba_rev: "PCBA REV",
            kickoff: "Kickoff",
            checklist_empty_title: "No checklists to display",
            no_checklist_found: "No checklist found for the selected client and year.",
            checklist_register_update: "Register update",
            checklist_comments: "Comments",
            checklist_comment_placeholder: "Enter your message, guidance or response...",
            checklist_attached_files: "Attached files",
            checklist_attach: "Attach",
            checklist_attachment_types: "File types: .jpg, .jpeg, .png, .pdf, .xls or .xlsx (max. 10MB total)",
            checklist_closed_on_before_phase_start: "The completion date cannot be before the phase start date.",
            file_name_too_long: "The file name is too long",
            files_exceed_max_size: "The total size of the attached files exceeds the limit of 10MB",
        }
    }
};

export {messages};
